"use client";

import Image from "next/image";
import {
  Select,
  SelectItem,
  SelectValue,
  SelectContent,
  SelectTrigger,
} from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";

import { Gem } from "lucide-react";

const TOKENS = [
  {
    name: "Bitcoin",
    img: "/icons/bitcoin.svg",
  },
  {
    name: "Ethereum",
    img: "/icons/ethereum.svg",
  },
];

export function RewardsCalculator() {
  return (
    <Card className="relative overflow-hidden bg-transparent bg-[url(/illustrations/dots.svg)]">
      <Image
        src="/illustrations/crypto-tokens.png"
        alt="crypto tokens"
        width={768}
        height={768}
        className="absolute top-1/2 right-10 z-0 size-48 -translate-y-1/2"
      />
      <div className="from-background-dark to-background-dark/50 absolute inset-0 z-10 size-full bg-linear-to-r" />
      <CardHeader className="relative z-20 px-6 pt-5 pb-6">
        <CardTitle className="text-lg">Rewards Calculator</CardTitle>
      </CardHeader>
      <CardContent className="xs:flex-row relative z-20 flex flex-col items-center gap-2 px-6 pt-0 pb-6">
        <div className="xs:gap-1 xs:flex-row xs:max-w-[340px] border-input bg-background flex h-full w-full max-w-full flex-col items-center rounded-lg border text-base shadow-sm">
          <Select>
            <SelectTrigger
              id="provider"
              className="xs:rounded-bl-lg xs:basis-1/2 xs:rounded-r-[3px] relative z-10 w-full rounded-b-[3px] border-0 shadow-none"
              aria-label="Select a provider"
            >
              <SelectValue placeholder="Select a provider" />
            </SelectTrigger>
            <SelectContent>
              {TOKENS.map(({ name, img }, key) => (
                <SelectItem value={name} key={key}>
                  <div className="flex items-center gap-2">
                    <Image
                      src={img}
                      alt={name}
                      className="size-4"
                      width={256}
                      height={256}
                    />
                    <div className="text-sm font-medium text-white">{name}</div>
                  </div>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <span className="xs:h-4 xs:w-px bg-border z-0 block h-px w-full shrink-0" />
          <Input
            type="number"
            placeholder="Enter amount"
            className="xs:rounded-tr-lg xs:rounded-l-[3px] xs:basis-1/2 relative z-10 rounded-t-[3px] border-0 shadow-none"
          />
        </div>
        <Button size="lg" className="xs:w-max w-full px-4">
          <Gem className="size-4 stroke-[1.5]" />
          Earn
        </Button>
      </CardContent>
      <CardFooter className="relative z-20 flex-col items-start justify-start gap-2 px-6 pb-6 text-start">
        <p className="text-foreground text-xs">Estimated rewards in one year</p>
        <p className="font-medium">
          <span className="text-success">0.00125 BTC</span>&nbsp;
          <span className="text-white">($121.25)</span>
        </p>
      </CardFooter>
    </Card>
  );
}
